import { TimeOffTypeBus } from './TimeOffTypeBus';
import { TimeOffStatusBus } from './TimeOffStatusBus';
import { PersonBus } from './PersonBus';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonFunctions } from '../static/common-functions';

export class TimeOffRequestBus extends BaseBus {
    constructor(data: TimeOffRequestBus = null) {
        super(data);
        if (data !== undefined && data !== null) {
            this.dateRequested = DateFunctions.getDate(data.dateRequested);
        }
    }

    setId(id: any) {
        this.timeOffRequestId = id;
    }
    setParentId(id: any) {
        // this.timeOffRequestId = id;
    }
    CID(): any {
        return this.timeOffRequestId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {

    }
    setFromForm(data: TimeOffRequestBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        if (!data.nonPaid) {
            this.nonPaid = false;
        }
        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
        }
        else {
            this.insertDt = dateNow;
        }

    }
    timeOffRequestId: any;
    companyId: any;
    requestedPersonId: any;
    dateRequested: Date;
    hoursRequested: number;
    statusId: number;
    insertDt: Date;
    insertedByUserId: any;
    notes: string;
    status: string;
    timeOffTypeId: any;
    timeOff: string;
    nonPaid: boolean;
    resourceName: string;
    rejectAcceptMsg: string;
    empNo: string;
    timeOffTypeName: string;
    timeOffType: TimeOffTypeBus;
    timeOffStatus: TimeOffStatusBus;
    requestPerson: PersonBus;

    public setForEdit() {
        this.hours = Math.floor(this.hoursRequested);
        let temp: number = this.hoursRequested - this.hours;
        if (temp > 0) {
            if (temp < .26) {
                this.mins = 15;
            }
            else if (temp < 51) {
                this.mins = 30;
            }
            else {
                this.mins = 45;
            }
        }
        else {
            this.mins = 0;
        }
    }
    public setForSave() {
        this.hoursRequested = this.hours + this.mins / 60;
        if (this.insertDt === undefined || this.insertDt === null) {
            this.insertDt = new Date(Date.now());
        }
    }
    setBeforeSave() {
        this.dateRequested = DateFunctions.getDateWithUTCOffset(this.dateRequested);
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
    }
    public hours: number;
    public mins: number;
    public managerName :string

}
